import { MonitoringService } from '@kit/monitoring-core';

export class ConsoleMonitoringService implements MonitoringService {
  identifyUser(data: { id: string }) {
    console.log(`[Console Monitoring] Identified user`, data);
  }

  captureException<
    Extra extends Record<string, unknown>,
    Config extends Record<string, unknown>,
  >(
    error: (Error & { digest?: string }) | null | undefined,
    extra?: Extra,
    config?: Config,
  ) {
    if (!error) {
      console.error(`[Console Monitoring] Caught exception`, {
        extra,
        config,
      });

      return;
    }

    console.error(`[Console Monitoring] Caught exception`, {
      name: error.name,
      message: error.message,
      digest: error.digest,
      stack: error.stack,
      extra,
      config,
      error,
    });
  }

  captureEvent(event: string) {
    console.log(`[Console Monitoring] Captured event: ${event}`);
  }

  ready() {
    return Promise.resolve();
  }
}
